import React, { useState } from "react";
import { Link } from "react-router-dom";
import "../login.css";
import axiosInstance from "../../../refershTokenManage/axiosConfig";
import CommonLoader from "../../../loader/CommonLoader";
import ReCAPTCHA from "react-google-recaptcha";

const ForgotPassword = () => {
    const RECAPTCHA_SITE_KEY = process.env.REACT_APP_RECAPTCHA_SITE_KEY;
    const [email, setEmail] = useState("");
    const [loading, setLoading] = useState(false);
    const [error, setError] = useState("");
    const [success, setSuccess] = useState("");
    const [recaptchaToken, setRecaptchaToken] = useState(null);
    const [emailError, setEmailError] = useState("");

    const handleChange = (e) => {
        setEmail(e.target.value);
        if (emailError) setEmailError("");
    };

    const handleRecaptchaChange = (token) => {
        setRecaptchaToken(token);
    };

    const handleSubmit = async (e) => {
        e.preventDefault();
        setError("");
        setSuccess("");
        setEmailError("");

        if (!email) {
            setEmailError("Email is required!");
            return;
        }

        if (!recaptchaToken && process.env.REACT_APP_RECAPTCHA_ENABLED === 'true') {
            setError("Please complete the reCAPTCHA!");
            return;
        }

        try {
            setLoading(true);
            await axiosInstance.post('/api/email-forgot-password', {
                email,
                recaptchaToken
            });

            setSuccess("Password reset link has been sent to your email.");
            setEmail("");
        } catch (error) {
            if (error.response?.data?.error === "User not found.") {
                setEmailError("if we find this email in our database, we will send a password reset notification to this email. Please check your email for further instructions");
            } else {
                setError("if we find this email in our database, we will send a password reset notification to this email. Please check your email for further instructions");
            }
        } finally {
            setLoading(false);
        }
    };

    return (
        <div className="main signInBackground">
            <div className="main__text-wrapper">
                <div className="form p-3 p-md-5">
                    <h3 className="mb-2 mb-md-5 fs-1">Forgot Password</h3>
                    <h4 className="mb-5 fs-2 fw-bold heading-color">Enter Your Email</h4>

                    <form className="forgot-password-form" onSubmit={handleSubmit}>
                        <div className="email_login mb-3">
                            <div className="input_email">
                                <input
                                    type="email"
                                    name="email"
                                    value={email}
                                    placeholder="Email"
                                    onChange={handleChange}
                                    required
                                    className={`loginFields ${emailError ? 'error' : ''}`}
                                />
                                {emailError && (
                                    <div className="field-error text-danger">
                                        {emailError}
                                    </div>
                                )}
                            </div>
                        </div>

                        {process.env.REACT_APP_RECAPTCHA_ENABLED === 'true' && (
                            <div className="recaptcha-signin mb-3">
                                <ReCAPTCHA
                                    sitekey={RECAPTCHA_SITE_KEY}
                                    onChange={handleRecaptchaChange}
                                />
                            </div>
                        )}

                        {error && (
                            <div className="success-message text-success fw-bold fs-6 text-center mb-3">
                                {error}
                            </div>
                        )}

                        {success && (
                            <div className="success-message text-success fw-bold fs-6 text-center mb-3">
                                {success}
                            </div>
                        )}

                        {loading && (
                            <div className="loader-overlay">
                                <CommonLoader />
                            </div>
                        )}

                        <button
                            type="submit"
                            className="submit"
                            disabled={loading}
                        >
                            Reset Password
                        </button>
                    </form>

                    <div className="newuser mt-3">
                        Remember your password?
                        <Link to="/sign-in" className="account ms-2">
                            Sign In
                        </Link>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default ForgotPassword;